import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'

import Select from 'components/Select'
import PartyCombobox from 'components/PartyCombobox'
import PropertyCombobox from '../PropertyCombobox'
import Comments from 'components/Comments'
import DueDatePicker from '../DueDatePicker'
import Lines from '../Lines'
import TransactionMemo from '../TransactionMemo'
import CheckBoxIsPaid from '../CheckBoxIsPaid'
import PaymentMethodSelect from '../PaymentMethodSelect'
import Attachments from 'components/Attachments'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { vendors } from 'selectors/entities'

var tmpAcct = ""
var tmpAddr = ""
var tmpPhn = ""
var memoEd = false

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.transactionID)
	  , vendors: vendors(state)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		let editing = props.editable
		let expsFilled = (exps) => {
			for(let i = 0; i<exps.length; i++){
			  if(!exps[i].amount || !exps[i].category) return false
		  }
		  return true
		}
		let party = props.transaction.paymentMethod != "QuickBooks" ?true:
			(props.transaction.vendorID && props.vendors[props.transaction.vendorID]
			&& props.vendors[props.transaction.vendorID].address
			&& (props.vendors[props.transaction.vendorID].phoneNumber || props.vendors[props.transaction.vendorID].cellNumber)
			&& props.vendors[props.transaction.vendorID].accountNumber) ?
			true:false
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<PaymentMethodSelect transactionID={props.transactionID} />
					{(props.transaction.paymentMethod || props.transaction.qbid) && <PartyCombobox objectID={props.transactionID} />}
					<div
						style={{
							clear: "both",
							paddingBottom: "30px",
							width: "100%",
							fontSize: "12px",
							color: "#FF0000",
							display: props.transaction.vendorID && props.transaction.paymentMethod == "QuickBooks"?
								(props.vendors[props.transaction.vendorID]
								&& props.vendors[props.transaction.vendorID].address
								&& (props.vendors[props.transaction.vendorID].phoneNumber || props.vendors[props.transaction.vendorID].cellNumber)
								&& props.vendors[props.transaction.vendorID].accountNumber) || props.transaction.qbid || !editing?
								"none":"":"none"
						}}
					>
						<p>Not enough data to pay with QB Banking.</p>
						<p style={{marginBottom: "28px"}}>Input required data and press update button</p>

						<div style={{display: (props.transaction.vendorID && props.vendors[props.transaction.vendorID] && !props.vendors[props.transaction.vendorID].accountNumber) || !editing? "" : "none" , marginTop: "-18px"}}>
							<TextField
								onClick={() => {if (!props.transaction.qbid && !editing) props.EDIT('transaction/bill')}}
								style={{fontSize: "14px", color: "#000", margin: "0px", float: "left"}}
								fullWidth={false}
								inputStyle={{color: "#000"}}
								underlineStyle={{borderBottom: "0px solid"}}
								disabled={!editing}
								underlineDisabledStyle={{borderBottom: "0px solid"}}
								hintText={<span>Input acct#</span>}
								hintStyle={{fontSize: "14px", fontStyle: "italic"}}
								defaultValue=""
								ref={`acct-${props.transactionID }`}
								key={`acct-${props.transactionID }`}
								onBlur={(evt)=>{
									tmpAcct = evt.target.value
									////console.log(tmpAcct);
								}}
							/>
							<div style={{
									borderRadius: "6px"
								  , width: "100px"
								  , color: "#FFF"
								  , textAlign: "center"
								  , height: "22px"
								  , border: "3px solid #3cd2ae"
								  , backgroundColor: "#3cd2ae"
								  , position: "relative"
								  , top: "13px"
								  , marginLeft: "260px"
								  , cursor: "pointer"
								  , display: editing ? "" : "none"
								}}
								title="Update acct#"
								onClick={() => {
									props.DOC_UPDATE({
										_id: props.transaction.vendorID
									  , accountNumber: tmpAcct
									})
								}}
							>
								Update acct#
							</div>
						</div>
						<div style={{display: props.transaction.vendorID && props.vendors[props.transaction.vendorID]? props.vendors[props.transaction.vendorID].phoneNumber||props.vendors[props.transaction.vendorID].cellNumber ? "none" : "" : "none" , marginTop: "-18px", clear: "both"}}>
							<TextField
								onClick={() => {if (!props.transaction.qbid && !editing) props.EDIT('transaction/bill')}}
								style={{fontSize: "14px", color: "#000", margin: "0px", float: "left"}}
								fullWidth={false}
								inputStyle={{color: "#000"}}
								underlineStyle={{borderBottom: "0px solid"}}
								disabled={!editing}
								underlineDisabledStyle={{borderBottom: "0px solid"}}
								hintText={<span>Input phone</span>}
								hintStyle={{fontSize: "14px", fontStyle: "italic"}}
								defaultValue=""
								ref={`phn-${props.transactionID }`}
								key={`phn-${props.transactionID }`}
								onBlur={(evt)=>{
									tmpPhn = evt.target.value
									//console.log(tmpPhn);
								}}
							/>
							<div style={{
									borderRadius: "6px"
								  , width: "100px"
								  , color: "#FFF"
								  , textAlign: "center"
								  , height: "22px"
								  , border: "3px solid #3cd2ae"
								  , backgroundColor: "#3cd2ae"
								  , position: "relative"
								  , top: "13px"
								  , marginLeft: "260px"
								  , cursor: "pointer"
								  , display: editing ? "" : "none"
								}}
								title="Update phone"
								onClick={() => {
									props.DOC_UPDATE({
										_id: props.transaction.vendorID
									  , phoneNumber: tmpPhn
									})
								}}
							>
								Update phone
							</div>
						</div>
						<div style={{display: props.transaction.vendorID  && props.vendors[props.transaction.vendorID]? props.vendors[props.transaction.vendorID].address ? "none" : "" : "none" , marginTop: "-18px", clear: "both"}}>
							<TextField
								onClick={() => {if (!props.transaction.qbid && !editing) props.EDIT('transaction/bill')}}
								style={{fontSize: "14px", color: "#000", margin: "0px", float: "left"}}
								fullWidth={false}
								multiLine={true}
								inputStyle={{color: "#000"}}
								underlineStyle={{borderBottom: "0px solid"}}
								disabled={!editing}
								underlineDisabledStyle={{borderBottom: "0px solid"}}
								hintText={<span>Input address</span>}
								hintStyle={{fontSize: "14px", fontStyle: "italic"}}
								defaultValue=""
								ref={`addr-${props.transactionID }`}
								key={`addr-${props.transactionID }`}
								onBlur={(evt)=>{
									tmpAddr = evt.target.value
									//console.log(tmpAddr);
								}}
							/>
							<div style={{
									borderRadius: "6px"
								  , width: "100px"
								  , color: "#FFF"
								  , textAlign: "center"
								  , height: "22px"
								  , border: "3px solid #3cd2ae"
								  , backgroundColor: "#3cd2ae"
								  , position: "relative"
								  , top: "13px"
								  , marginLeft: "260px"
								  , cursor: "pointer"
								  , display: editing ? "" : "none"
								}}
								title="Update address"
								onClick={() => {
									props.DOC_UPDATE({
										_id: props.transaction.vendorID
									  , address: tmpAddr
									})
								}}
							>
								Update addr
							</div>
						</div>
					</div>
					{((props.transaction.paymentMethod || props.transaction.qbid) && party &&(props.transaction.partyID || props.transaction.vendorID) || !editing) && <PropertyCombobox objectID={props.transactionID} />}
				</div>
				{(((props.transaction.paymentMethod || props.transaction.qbid) && party && (props.transaction.partyID || props.transaction.vendorID) && props.transaction.propertyID) || !editing) && <Lines objectID={props.transactionID} editable={props.editable} />}
				<Divider style={{margin: "0"}}/>
				{((props.transaction.paymentMethod || props.transaction.qbid) && party && (props.transaction.partyID || props.transaction.vendorID) && props.transaction.propertyID && expsFilled(props.transaction.expenses || []) || !editing) &&
					<div style={{width: "100%", padding:"0 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
						<DueDatePicker objectID={props.transactionID} />
						<TransactionMemo objectID={props.transactionID} />
						<CheckBoxIsPaid objectID={props.transactionID} />
					</div>
				}
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/BillForm/LeftSide.js